import Slider from "react-slick";
import { SlidePhoto } from "./SlidePhoto";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { createStyles } from "@material-ui/core";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        slidePhoto: {
            // display: 'flex',
            // maxWidth: '296px',
            // height: '296px',
            // marginBottom: '50px'
        },
        previewContainer: {
            marginBottom: theme.spacing(5),
            background: "#5e5e5e",
            maxWidth: "295px",
            maxHeight: "295px",
            marginLeft: "auto",
            marginRight: "auto",
        },
    })
);

export const PreviewPhotos = (props: {
    photos: any;
    idProperty: string;
    isUpdating: boolean;
    onDeletePhoto?: (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => void;
}) => {
    const classes = styles();
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const removeThePhoto = (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => {
        if (props.onDeletePhoto)
            props.onDeletePhoto(idProperty, idPhoto, photoName);
    };

    return (
        <div className={classes.previewContainer}>
            <Slider {...settings}>
                {props.photos.map((photo: any, index: any) => (
                    <SlidePhoto
                        key={index}
                        filename={photo.filename}
                        fileURL={photo.url}
                        isUpdating={props.isUpdating}
                        idProperty={props.idProperty}
                        idPhoto={photo.id}
                        removeThePhoto={removeThePhoto}
                    />
                ))}
            </Slider>
        </div>
    );
};
